import './footer.css'

const Footer = () => {
    return (
        <div className="footer-container">
            <a href="https://github.com/fasbender?tab=repositories">Copyright &copy; Faisal Bin Alamgir</a>
        </div>
    )
}

export default Footer
